import React from 'react';
import { useIntl } from 'react-intl';
import {
  Box,
  Divider,
  Stack,
  Typography,
  IconButton,
  Tooltip,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { CenteredFlexBox } from '../../../../Components/FlexBox';
import SettingValue from './SettingValue';
import CodeBlock from './CodeBlock';

// Shared by the header and the rows so the columns line up; the value gets the most room.
const COLUMNS = {
  name: { flex: 1.2, minWidth: 0 },
  value: { flex: 2.5, minWidth: 0 },
  description: { flex: 1.5, minWidth: 0 },
};

const SystemParametersListItems = function SystemParametersListItems({
  settings,
  onClick,
  searchedValue,
}) {
  const intl = useIntl();

  const openEditDialogHandler = (setting) => {
    onClick(setting);
  };

  const filteredSettings =
    settings?.filter(
      (s) =>
        !searchedValue ||
        s.settingName?.toLowerCase()?.includes(searchedValue?.toLowerCase())
    ) ?? [];

  return (
    <div>
      <CenteredFlexBox
        gap="30px"
        sx={{
          backgroundColor: 'background.paper',
          padding: '16px',
          position: 'sticky',
          top: 0,
          zIndex: 1,
        }}
      >
        <Typography variant="h6" sx={COLUMNS.name}>
          {intl.messages.NAME}
        </Typography>
        <Typography variant="h6" sx={COLUMNS.value}>
          {intl.messages.VALUE}
        </Typography>
        <Typography variant="h6" sx={COLUMNS.description}>
          {intl.messages.DESCRIPTION}
        </Typography>
        <Box sx={{ width: 40, flexShrink: 0 }} />
      </CenteredFlexBox>

      <Stack divider={<Divider />}>
        {filteredSettings.map((setting) => (
          <CenteredFlexBox
            key={setting.settingName}
            padding="16px"
            gap="30px"
            sx={{ alignItems: 'flex-start' }}
          >
            <Box sx={COLUMNS.name}>
              <CodeBlock copyText={setting.settingName}>
                {setting.settingName}
              </CodeBlock>
            </Box>
            <Box sx={COLUMNS.value}>
              <SettingValue value={setting.settingValue} />
            </Box>
            <Typography
              variant="body1"
              sx={{ ...COLUMNS.description, overflowWrap: 'anywhere' }}
            >
              {setting.description}
            </Typography>
            <Tooltip title={intl.messages.EDIT_SYSTEM_PARAMETER}>
              <IconButton
                key={settings.settingName}
                onClick={() => openEditDialogHandler(setting)}
              >
                <EditIcon />
              </IconButton>
            </Tooltip>
          </CenteredFlexBox>
        ))}
      </Stack>
    </div>
  );
};

export default SystemParametersListItems;
